var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-projects-grid"},[_c('b-row',_vm._l((_vm.projects),function(project){return _c('b-col',{key:project.id,staticClass:"mb-4",attrs:{"cols":"12","md":"6","lg":"4","xl":"3"}},[_c('project-grid-card',{attrs:{"project":project}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }